import { FC } from "react";

import NotificationContext from "./notificationContext";
import { INotificationContext } from "./notification.types";
import FullNotificationList from "./FullNotificationList";
import { DropdownNotificationList } from "./DropdownNotificationList";
import { useGetToken } from "./utils";

export const BaseNotificationsList: FC<NotificationsListProps> = ({
  type,
  query,
  notificationPreviewData,
  customNotificationDocumentInject,
  onRedirect,
}) => {
  useGetToken();

  return (
    <NotificationContext.Provider
      value={{
        query,
        customNotificationDocumentInject,
        notificationPreviewData,
        onRedirect,
      }}
    >
      {type === "full" ? <FullNotificationList /> : type === "dropdown" ? <DropdownNotificationList /> : null}
    </NotificationContext.Provider>
  );
};

interface NotificationsListProps extends INotificationContext {
  type: "full" | "dropdown";
}
